import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import V2Layout from '../components/V2Layout'
import SEO from '../components/SEO'
import axios from 'axios'

const API = ''

function stripHtml(html) {
    if (!html) return ''
    return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
}

function formatDate(d) {
    if (!d) return ''
    return new Date(d + 'Z').toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
}

const NewsScreen = () => {
    const [articles, setArticles] = useState([])

    useEffect(() => {
        axios.get(`${API}/api/news`).then(r => setArticles(r.data)).catch(() => { })
    }, [])

    return (
        <V2Layout pageClass="pfc-news">
            <SEO
                title="News & Announcements"
                description="Company updates, program milestones, and industry news from Precision Fluid Controls."
            />
            <section className="pfc-page-hero">
                <div className="pfc-page-hero-inner">
                    <p className="v2-section-label">Latest Updates</p>
                    <h1 className="pfc-page-hero-title">News &amp; Announcements</h1>
                    <p className="pfc-page-hero-sub">
                        Company updates, program milestones, and industry news from Precision Fluid Controls.
                    </p>
                </div>
            </section>

            <section className="pfc-news-body">
                <div className="pfc-news-inner">
                    {articles.length === 0 ? (
                        <p className="pfc-news-empty">No news articles yet.</p>
                    ) : (
                        <div className="pfc-news-grid">
                            {articles.map(a => (
                                <Link to={`/news/${a.id}`} className="pfc-news-card" key={a.id}>
                                    {a.header_image && (
                                        <div className="pfc-news-card-img-wrap">
                                            <img
                                                src={`${API}${a.header_image}`}
                                                alt={a.title}
                                                className="pfc-news-card-img"
                                            />
                                        </div>
                                    )}
                                    <div className="pfc-news-card-body">
                                        <span className="pfc-news-card-date">{formatDate(a.created_at)}</span>
                                        <h2 className="pfc-news-card-title">{a.title}</h2>
                                        <p className="pfc-news-card-excerpt">
                                            {stripHtml(a.body).substring(0, 160)}{stripHtml(a.body).length > 160 ? '…' : ''}
                                        </p>
                                        <span className="pfc-news-card-cta">Read more →</span>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    )}
                </div>
            </section>
        </V2Layout>
    )
}

export default NewsScreen
